module.exports = __webpack_public_path__ + "bd656790ec46cba9b0b26ffe6bb16e6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_xlarge_x1/public/games/Dawn-of-War-II.jpg
// module id = 325
// module chunks = 0